// extracted by css-extract-rspack-plugin
export default {"Container":"MergeBoxNudgeSection-module__Container__wLdT0","TitleRow":"MergeBoxNudgeSection-module__TitleRow__VFyMJ","Actions":"MergeBoxNudgeSection-module__Actions__mJ_X6"};